module.exports = __webpack_public_path__ + "files/ce907b9f60d0018602fe3bed8266dc74.svg";